export default __webpack_public_path__ + "static/media/logo-light.f6b71fbd.png";